"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.updateStateValues = exports.toggleSelectAll = exports.toggleRowSelection = exports.toggleRowExpansion = exports.toggleColumnVisibility = exports.toggleColumnFixed = exports.setSelectedRows = exports.setExportableColumns = exports.setColumnsInitialWidth = exports.selectSingleRow = exports.reorderColumns = exports.onColumnResizeEnd = exports.loadMoreDataStop = exports.loadMoreDataStart = exports.loadMoreData = exports.isTableBusy = exports.createAction = exports.allRowsSelected = exports.UPDATE_STATE_VALUES = exports.TOGGLE_SELECT_ALL = exports.TOGGLE_ROW_SELECTION = exports.TOGGLE_ROW_EXPANSION = exports.TOGGLE_COLUMN_VISIBILITY = exports.TOGGLE_COLUMN_FIXED = exports.SET_SELECTED_ROWS = exports.SET_EXPORTABLE_COLUMNS = exports.SET_COLUMNS_INITIAL_WIDTH = exports.SELECT_SINGLE_ROW = exports.REORDER_COLUMNS = exports.LOAD_MORE_DATA_STOP = exports.LOAD_MORE_DATA_START = exports.LOAD_MORE_DATA = exports.IS_TABLE_BUSY = exports.COLUMN_RESIZE_END = exports.ALL_ROWS_SELECTED = void 0;
var LOAD_MORE_DATA_START = "@data_table/load_more_data_start";
exports.LOAD_MORE_DATA_START = LOAD_MORE_DATA_START;
var LOAD_MORE_DATA = "@data_table/load_more_data";
exports.LOAD_MORE_DATA = LOAD_MORE_DATA;
var LOAD_MORE_DATA_STOP = "@data_table/load_more_data_stop";
exports.LOAD_MORE_DATA_STOP = LOAD_MORE_DATA_STOP;
var UPDATE_STATE_VALUES = "@data_table/update_state_values";
exports.UPDATE_STATE_VALUES = UPDATE_STATE_VALUES;
var REORDER_COLUMNS = "@data_table/reorder_columns";
exports.REORDER_COLUMNS = REORDER_COLUMNS;
var TOGGLE_COLUMN_VISIBILITY = "@data_table/toggle_column_visibility";
exports.TOGGLE_COLUMN_VISIBILITY = TOGGLE_COLUMN_VISIBILITY;
var TOGGLE_COLUMN_FIXED = "@data_table/toggle_column_fixed";
exports.TOGGLE_COLUMN_FIXED = TOGGLE_COLUMN_FIXED;
var TOGGLE_SELECT_ALL = "@data_table/toggle_select_all";
exports.TOGGLE_SELECT_ALL = TOGGLE_SELECT_ALL;
var TOGGLE_ROW_SELECTION = "@data_table/toggle_row_selection";
exports.TOGGLE_ROW_SELECTION = TOGGLE_ROW_SELECTION;
var SET_SELECTED_ROWS = "@data_table/set_selected_rows";
exports.SET_SELECTED_ROWS = SET_SELECTED_ROWS;
var SELECT_SINGLE_ROW = "@data_table/select_single_row";
exports.SELECT_SINGLE_ROW = SELECT_SINGLE_ROW;
var SET_EXPORTABLE_COLUMNS = "@data_table/set_exportable_columns";
exports.SET_EXPORTABLE_COLUMNS = SET_EXPORTABLE_COLUMNS;
var SET_COLUMNS_INITIAL_WIDTH = "@data_table/set_columns_initial_width";
exports.SET_COLUMNS_INITIAL_WIDTH = SET_COLUMNS_INITIAL_WIDTH;
var TOGGLE_ROW_EXPANSION = "@data_table/toggle_row_expansion";
exports.TOGGLE_ROW_EXPANSION = TOGGLE_ROW_EXPANSION;
var ALL_ROWS_SELECTED = "@data_table/all_rows_selected";
exports.ALL_ROWS_SELECTED = ALL_ROWS_SELECTED;
var IS_TABLE_BUSY = "@data_table/is_loading";
exports.IS_TABLE_BUSY = IS_TABLE_BUSY;
var COLUMN_RESIZE_END = "@data_table/column_resize_end";
exports.COLUMN_RESIZE_END = COLUMN_RESIZE_END;

var createAction = function createAction(type) {
  return function (payload) {
    return {
      type: type,
      payload: payload
    };
  };
};

exports.createAction = createAction;
var updateStateValues = createAction(UPDATE_STATE_VALUES);
exports.updateStateValues = updateStateValues;
var reorderColumns = createAction(REORDER_COLUMNS);
exports.reorderColumns = reorderColumns;
var toggleColumnVisibility = createAction(TOGGLE_COLUMN_VISIBILITY);
exports.toggleColumnVisibility = toggleColumnVisibility;
var toggleColumnFixed = createAction(TOGGLE_COLUMN_FIXED);
exports.toggleColumnFixed = toggleColumnFixed;
var setColumnsInitialWidth = createAction(SET_COLUMNS_INITIAL_WIDTH);
exports.setColumnsInitialWidth = setColumnsInitialWidth;
var toggleSelectAll = createAction(TOGGLE_SELECT_ALL);
exports.toggleSelectAll = toggleSelectAll;
var toggleRowSelection = createAction(TOGGLE_ROW_SELECTION);
exports.toggleRowSelection = toggleRowSelection;
var setSelectedRows = createAction(SET_SELECTED_ROWS);
exports.setSelectedRows = setSelectedRows;
var toggleRowExpansion = createAction(TOGGLE_ROW_EXPANSION);
exports.toggleRowExpansion = toggleRowExpansion;
var selectSingleRow = createAction(SELECT_SINGLE_ROW);
exports.selectSingleRow = selectSingleRow;
var loadMoreDataStart = createAction(LOAD_MORE_DATA_START);
exports.loadMoreDataStart = loadMoreDataStart;
var loadMoreData = createAction(LOAD_MORE_DATA);
exports.loadMoreData = loadMoreData;
var loadMoreDataStop = createAction(LOAD_MORE_DATA_STOP);
exports.loadMoreDataStop = loadMoreDataStop;
var setExportableColumns = createAction(SET_EXPORTABLE_COLUMNS);
exports.setExportableColumns = setExportableColumns;
var allRowsSelected = createAction(ALL_ROWS_SELECTED);
exports.allRowsSelected = allRowsSelected;
var isTableBusy = createAction(IS_TABLE_BUSY);
exports.isTableBusy = isTableBusy;
var onColumnResizeEnd = createAction(COLUMN_RESIZE_END);
exports.onColumnResizeEnd = onColumnResizeEnd;